import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, roles, requireSuperAdmin, allowSuperAdmin }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
        <div className="w-8 h-8 rounded-full border-4 border-brand/20 border-t-brand animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Super-admins are platform-owners and must never see per-tenant pages.
  // They're only allowed on routes explicitly marked requireSuperAdmin or allowSuperAdmin.
  if (user.is_super_admin && !requireSuperAdmin && !allowSuperAdmin) {
    return <Navigate to="/super-admin" replace />;
  }
  if (requireSuperAdmin && !user.is_super_admin) return <Navigate to="/dashboard" replace />;
  if (roles) {
    const userRoles = user.roles || (user.role ? [user.role] : []);
    if (!roles.some(r => userRoles.includes(r))) return <Navigate to="/dashboard" replace />;
  }
  return children;
}
